// Helper to open external URLs safely bypassing Firefox COOP issues
// that occur with rel="noopener noreferrer" + target="_blank" combinations
// when the parent page has Cross-Origin-Opener-Policy set.
export const openExternal = (url) => (e) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  try {
    const w = window.open(url, "_blank");
    if (w) {
      try {
        w.opener = null;
      } catch (_) {
        // ignore - cross-origin opener access blocked, which is desired
      }
    } else {
      // popup blocked: fallback to same-tab navigation
      window.location.href = url;
    }
  } catch (_) {
    window.location.href = url;
  }
};
